import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { SizeUnit } from '@core/enums/size-unit.enum';
import { BytesToUnitPipe } from '@shared/pipes';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'sky-media-file',
  imports: [MatIcon, MatIconButton, NgClass, BytesToUnitPipe, TranslocoDirective],
  templateUrl: './media-file.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaFileComponent {
  fileName = input.required<string>();
  fileSize = input.required<number>();
  isFileValid = input<boolean>();
  fileUrl = input<string>();

  removeFile = output<void>();

  protected readonly SizeUnit = SizeUnit;

  removeFileClick() {
    this.removeFile.emit();
  }
}
